import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProgressComponent } from './form/factory-worker-hk/progress/progress.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { RegisterComponent } from './pages/auth/register/register.component';
import { CeoComponent } from './pages/ceo/ceo.component';
import { HistoryComponent } from './pages/history/history.component';
import { HomeComponent } from './pages/home/home.component';
import { JobComponent } from './pages/job/job.component';
import { FactoryWorkerHkComponent } from './form/factory-worker-hk/factory-worker-hk.component';
import { ContactComponent } from './pages/contact/contact.component';
import { RecruitmentProcessComponent } from './pages/recruitment-process/recruitment-process.component';
import { OurDeploymentComponent } from './pages/our-deployment/our-deployment.component';
import { EngineeringAndConstructionComponent } from './pages/industries/engineering-and-construction/engineering-and-construction.component';
import { MedicalComponent } from './pages/industries/medical/medical.component';
import { HotelAndRestaurantComponent } from './pages/industries/hotel-and-restaurant/hotel-and-restaurant.component';
import { ManufacturingComponent } from './pages/industries/manufacturing/manufacturing.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { GeneralInfoComponent } from './pages/general-info/general-info.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  {
    path: 'history',
    component: HistoryComponent
  },
  {
    path: 'ceo',
    component: CeoComponent
  },
  {
    path: 'job',
    component: JobComponent
  },
  {
    path: 'factory-worker-hk',
    component: FactoryWorkerHkComponent
  },
  {
    path: 'contact',
    component: ContactComponent
  },
  {
    path: 'recruitment-process',
    component: RecruitmentProcessComponent
  },
  {
    path: 'our-deployment',
    component: OurDeploymentComponent
  },
  {
    path: 'engineering',
    component: EngineeringAndConstructionComponent
  },
  {
    path: 'medical',
    component: MedicalComponent
  },
  {
    path: 'hotel-and-restaurant',
    component: HotelAndRestaurantComponent
  },
  {
    path: 'manufacturing',
    component: ManufacturingComponent
  },
  {
    path: 'gallery',
    component: GalleryComponent
  },
  {
    path: 'general-information',
    component: GeneralInfoComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
